import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getMobileCountriesChartName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_utils/countryName';

const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = 'line',
    lineData,
    metricSegVal,
    dateType,
    regionSegVal,
    baseReleaseTime,
    earliestPeriod,
    isStackLine,
    regionsCountries,
    retentionMetricSource = 'appannie',
  } = props;

  const chartDataSource =
    retentionMetricSource === 'sensortower' ? 'sensortower' : 'appannie';

  // console.log('ChannelsCardChannelsCard', props);

  const { locale, formatMessage } = useIntlExtend();
  const localizedOthersName = formatMessage({ id: 'dbi_others' });
  const [chartLoading, setChartLoading] = useState(false);

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      arr.push({
        source: chartDataSource,
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value,
      });
    }
    return arr;
  };

  const getMetricsList = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const objTemp = {
        cover: list[n].market,
        id: list[n].app_id,
        name: getMobileCountriesChartName({
          regionsCountries,
          countryCode: list[n].market,
          regionSegVal,
          fallbackName: list[n].name,
          localizedOthersName,
        }),
        history: getRpdTypeData(list[n].history || []),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in lineData) {
      arrGameData[lineData[n].metric] = getMetricsList(lineData[n].detail_list);
    }
    return arrGameData;
  }, [lineData, regionsCountries, regionSegVal, dateType, localizedOthersName, locale, chartDataSource]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: metricSegVal,
    topChartsType: 'stats-retentionmonthly-line',
    imageType: regionSegVal,
    titleNow: metricSegVal,
    isStackLine,
    dateType,
    baseReleaseTime: showTimeByDateType(baseReleaseTime, dateType?.toLocaleLowerCase()),
    earliestPeriod: showTimeByDateType(earliestPeriod, dateType?.toLocaleLowerCase()),
  });

  return (
    <>
      <div className="card-line">
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          // isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
